import Model from '@/lib/data/Model';
import RoleFunction from '@/data/RoleFunction';

class Role extends Model {
    static idProperty = 'id';

    fields = [
        'id',
        'name',
        'display_name', // in the future it might be useful
        'organization_id',
        { name: 'system_managed', type: 'bool' },
        {
            name: 'functions',
            association: {
                type: 'many',
                model: RoleFunction,
            },
        },
    ];

    constructor(data) {
        super(data);
        this.init();
    }

    get roleName() {
        return this.display_name || this.name;
    }

    api = [
        {
            name: 'update',
            url: '/role/save',
            associated: {
                name: false,
                organization_id: false,
                system_managed: false,
                functions: {
                    module_name: false,
                    function_name: false,
                    valid_access_code: false,
                },
            },
        },
    ];
}

export default Role;
